import { floatMul, floatSub } from "~/utils/num";

export function getProfit(thPrice = 0, salePrice = 0, num = 0) {
  return floatMul( floatSub(salePrice, thPrice), num );
}
